// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clearfix[data-v-3cba4b3e]:after,.clearfix[data-v-3cba4b3e]:before{content:\"\";width:0;height:0;clear:both}.drawer_footer[data-v-3cba4b3e]{position:absolute;bottom:0;width:100%}", ""]);
// Exports
module.exports = exports;
